// Ensure the YouTube Iframe API is loaded
let youtubePlayers = [];
window.initializeVideoTrackers = function () {
  // Find all iframes that have not had a youtube player object initialized
  const iframes = document.querySelectorAll('iframe[data-video-id]:not([data-progress-tracked])');
  iframes.forEach((iframe, index) => {
    youtubePlayers[index] = new YT.Player(iframe, {
      events: {
        onStateChange: onPlayerStateChange,
      },
    });
    // Initialize tracking state
    iframe.dataset.progressTracked = JSON.stringify([]);
  });
};

// Listen for player state changes
function onPlayerStateChange(event) {
  const player = event.target;
  const iframe = player.getIframe();
  const videoId = iframe.dataset.videoId;
  const videoTitle = player.videoTitle;
  const videoUrl = player.playerInfo.videoUrl;
  let videoDimensions = {
    videoProvider: 'youtube',
    videoId: videoId,
    videoTitle: videoTitle,
    videoUrl: videoUrl,
  };

  if (event.data === YT.PlayerState.PLAYING) {
    trackVideoStart(player, iframe, videoDimensions);
    monitorVideoProgress(player, videoDimensions);
  } else if (event.data === YT.PlayerState.ENDED) {
    trackVideoEnd(player, iframe, videoDimensions);
  }
}

// Function to gather video metrics
function gatherVideoMetrics(player) {
  if (player) {
    return {
      videoCurrentTime: player.playerInfo.currentTime,
      videoDuration: player.playerInfo.duration,
    };
  }
  return {};
}

// Track Video Start
function trackVideoStart(player, iframe, videoDimensions) {
  if (!iframe.dataset.trackedStart) {
    let videoMetrics = gatherVideoMetrics(player);
    let dimensionsAndMetrics = Object.assign({}, videoDimensions, videoMetrics);
    dimensionsAndMetrics.videoPercent = 0;
    publishEvent('video_start', dimensionsAndMetrics);
    iframe.dataset.trackedStart = true;
  }
}

// Monitor Video Progress
function monitorVideoProgress(player, videoDimensions) {
  const progressPoints = [10, 25, 50, 75]; // Define progress milestones
  const iframe = player.getIframe();

  const checkProgress = setInterval(() => {
    let progressTracked = JSON.parse(iframe.dataset.progressTracked);
    if (player.playerInfo.playerState !== YT.PlayerState.PLAYING) {
      clearInterval(checkProgress); // Stop if video is not playing
    } else {
      const videoMetrics = gatherVideoMetrics(player);
      let dimensionsAndMetrics = Object.assign({}, videoDimensions, videoMetrics);
      const percentComplete = Math.floor((videoMetrics.videoCurrentTime / videoMetrics.videoDuration) * 100);

      progressPoints.forEach((point) => {
        if (percentComplete >= point && !progressTracked.includes(point)) {
          dimensionsAndMetrics.videoPercent = point;
          publishEvent('video_progress', dimensionsAndMetrics);
          progressTracked.push(point);
          iframe.dataset.progressTracked = JSON.stringify(progressTracked);
        }
      });
    }
  }, 1000); // Check progress every second
}

// Track Video End
function trackVideoEnd(player, iframe, videoDimensions) {
  if (!iframe.dataset.trackedEnd) {
    const videoMetrics = gatherVideoMetrics(player);
    let dimensionsAndMetrics = Object.assign({}, videoDimensions, videoMetrics);
    dimensionsAndMetrics.videoPercent = 100;
    publishEvent('video_end', dimensionsAndMetrics);
    iframe.dataset.trackedEnd = true;
  }
}

// Shopify Web Pixel API Event Publisher
function publishEvent(eventName, payload) {
  window.Shopify?.analytics?.publish(eventName, payload);
}

// Load YouTube Iframe API
const tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
document.head.appendChild(tag);
window.onload = () => {
  window.initializeVideoTrackers();
};
